var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDraganddrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163994",
    "data-name": "Group 163994",
    transform: "translate(-17022 9871)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141307",
    "data-name": "Rectangle 141307",
    width: 24,
    height: 24,
    transform: "translate(17022 -9871)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84552",
    "data-name": "Path 84552",
    d: "M138.736,58.369l-2.728-2.727a.909.909,0,1,0-1.285,1.285L135.9,58.1h-5.988V52.114l1.176,1.176a.909.909,0,0,0,1.285-1.285l-2.727-2.728a.908.908,0,0,0-1.285,0l-2.728,2.728a.909.909,0,0,0,1.285,1.285l1.176-1.175V58.1H122.1l1.176-1.176A.909.909,0,0,0,122,55.642l-2.728,2.727a.908.908,0,0,0,0,1.285L122,62.381A.909.909,0,1,0,123.28,61.1l-1.175-1.176h5.988v5.988l-1.177-1.176a.909.909,0,0,0-1.285,1.285l2.727,2.727a.908.908,0,0,0,1.285,0l2.727-2.727a.909.909,0,0,0-1.285-1.285l-1.176,1.175V59.921H135.9L134.723,61.1a.909.909,0,1,0,1.285,1.285l2.727-2.727a.908.908,0,0,0,0-1.285Z",
    transform: "translate(16904.998 -9918.012)",
    fill: "#195165"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraganddrop);
export default __webpack_public_path__ + "static/media/icon-draganddrop.97d2e7c167b5b6fd49d66bcdf20c161b.svg";
export { ForwardRef as ReactComponent };